<template>
  <div class="sr-result">
    <!-- No results -->
    <div
      class="no-search-result"
      v-if="allSearchClients.length === 0 && allSearchOthers.length === 0"
    >
      No results
    </div>

    <!-- Clients -->
    <template v-if="allSearchClients.length > 0">
      <h4>Clients:</h4>
      <div
        class="sr-result-list"
        v-for="client in allSearchClients"
        :key="client.type + client.id"
      >
        <individual-result :client="client" />
      </div>
    </template>

    <!-- Others -->
    <template v-if="allSearchOthers.length > 0">
      <h4 class="sub-title">Others:</h4>
      <div
        class="sr-result-list"
        v-for="client in allSearchOthers"
        :key="client.type + client.id"
      >
        <individual-result :client="client" />
      </div>
    </template>
  </div>
</template>

<script>
import IndividualResult from "./IndividualResult";
import { addNewChatAndCallMixin } from "../../../mixins/addNewChatAndCallMixin";

export default {
  mixins: [addNewChatAndCallMixin],
  components: {
    IndividualResult
  }
};
</script>

<style scoped>
.no-search-result {
  display: block;
}
</style>
